import session from 'frontend/shared/javascripts/util/session'

up.compiler(
  '[data-duplicate-playlist-button]',
  (element: HTMLElement, { userId }: { userId: number }) => {
    if (session.signedIn && userId !== session.userId) {
      element.classList.remove('d-none')
    }
  },
)

up.compiler('[data-playlist-duplicated-button]', (element: HTMLElement) => {
  if (new URLSearchParams(window.location.search).has('duplicated')) {
    element.classList.remove('d-none')
  }
})
